import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import Module from "utilities/global/sparta-module-utility/6.3.1/js/sparta-module-utility";
import currentWidgetDetails from "utilities/platform/widget-details";














export default class AhPubsubUtility {





    constructor(options = {}) {
        this.parentModule = options.parentModule;
        this.ahCawCommons = ahCawCommons;

        this.bindThisContext();
    }

    bindThisContext() {
        this.ahCawCommons.bindThisContext(
            [
                "_doPublishEvent",
                "_doSubscribeEvent"
            ],
            this,
            ""
        );
        return this;
    }

    _doPublishEvent(eventName, data, includeNamespace) {
        let noNamespace = typeof(includeNamespace) != 'undefined' && !includeNamespace;
        const eventToPublish = noNamespace?eventName:this._getNSAwareEvent(eventName);
        this.parentModule._debug(`Publishing Event ${noNamespace?'(noNamespace)':''}: ${eventToPublish}`);
        this.parentModule.Events.pub(eventToPublish, data);
    }

    _doSubscribeEvent(eventName, refMethod, includeNamespace) {
        let noNamespace = typeof(includeNamespace) != 'undefined' && !includeNamespace;
        const eventToSubscribe = noNamespace?eventName:this._getNSAwareEvent(eventName);
        this.parentModule._debug(`Subscribed to Event ${noNamespace?'(noNamespace)':''}: ${eventToSubscribe}`);
        this.parentModule.Events.sub(eventToSubscribe, refMethod);
    }

    _getNSAwareEvent(eventName) {
        return eventName + ":" + this.parentModule["events-namespace"];
    }
}
